import React from "react";
import { connect } from "react-redux";
import PaypalButton from "./paypal-button.component";
import BillingAddress from "../stripe/billing-address.component";
import { selectCurrentPayment } from "../../../redux/payment/payment.selectors";

function PaypalPayment({ payment }) {
  return (
    <div className="mt-3 p-3">
      <BillingAddress />
      {payment.set_billing_address && <div>
        <p className="mb-2">Approve your payment with PayPal below.</p>
        <PaypalButton />
      </div>}
    </div>
  );
}
export default connect(state => ({ payment: selectCurrentPayment(state) }))(PaypalPayment);
